import { alpha, Autocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';

import { type DropdownListItem } from '../../ComboBox/ComboBox';

export const StyledAutocomplete = styled(
  Autocomplete<DropdownListItem, boolean, boolean, undefined>
)(({ theme }) => ({
  '& .MuiAutocomplete-root': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiButtonBase-root.MuiChip-root': {
    backgroundColor: alpha(theme.palette.common.black, 0.08),
    // TODO: no VDS token for this value — needs designer input (fontSize 13)
    fontSize: '13px',
    fontWeight: 400,
    color: theme.palette.text.secondary,
    lineHeight: '18px',
    letterSpacing: '0.16px',
    height: '24px',
    '& .MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },
  },
}));
